import React from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import ScrollToTop from "../component/ScrollToTop";
export default function Corebanking() {
  return (
    <>
      <ScrollToTop>
        <Header />
        <section className="section_padding">
          <div className="container">
            
          </div>
        </section>
        <Footer />
      </ScrollToTop>
    </>
  );
}
